import { render, staticRenderFns } from "./DossierSuivi.vue?vue&type=template&id=4608dee0&scoped=true&"
import script from "./DossierSuivi.js?vue&type=script&lang=js&"
export * from "./DossierSuivi.js?vue&type=script&lang=js&"
import style0 from "./DossierSuivi.vue?vue&type=style&index=0&id=4608dee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4608dee0",
  null
  
)

export default component.exports